import {
  browserDefaultTimezone,
  getFirstRenewalDateOnChargeDay,
  getNormalFirstRenewalDate,
  StripeRecurringInterval,
  SubscriptionChargeDay,
} from "@simplyk/common";

import { getSubscriptionIntervalFromStripeInterval } from "@/common/helpers/donationRecurrence";

export const getChargeDayRenewalDate = (
  stripeRecurrenceInterval: StripeRecurringInterval | null | undefined,
  chargeDay: SubscriptionChargeDay | null | undefined
): Date | null => {
  const recurrenceInterval = getSubscriptionIntervalFromStripeInterval(stripeRecurrenceInterval);
  if (!recurrenceInterval) {
    return null;
  }
  const movedRenewalDate = chargeDay
    ? getFirstRenewalDateOnChargeDay({ chargeDay, recurrenceInterval, timezone: browserDefaultTimezone })
    : null;
  return movedRenewalDate ?? getNormalFirstRenewalDate({ recurrenceInterval, timezone: browserDefaultTimezone });
};
